import React from 'react';
import styled from "styled-components";
import Typography from '@mui/material/Typography';

const DivFooter = styled.footer`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    background: rgba(5, 21, 100, 0.35);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);

    border-top: 1px solid rgba(255, 255, 255, 0.4);
    padding: 4px 0;
    
    color: white;
    text-align: center;
    font-size: 11px;

    z-index: 2;
`;

const Cpright = styled(Typography)`
    font-size: 11px !important;
    font-weight: bold !important;
    margin: 0 !important;
    padding: 0 !important;
`;

const Footer = () => {
    return (
        <DivFooter>
            <Cpright variant="body2" component="div">
                Copyright © 2022 Coinfo. Todos os direitos reservados.
            </Cpright>
        </DivFooter>
    );
};

export default Footer;
